import { createPaginatedKey } from "api/keys";

export const usersKeys = {
  user: {
    list: createPaginatedKey("users"),
  },
};
